import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Homepage } from "views/homepage/homepage";
import Footer from "views/Footer/Footer";
import Header from "views/Header/header";
import { PrivacyPolicy } from "views/privacyPolicy/privacyPolicy";
import { Services } from "views/services/services";
import { Contact } from "views/Contact/contact";
import { convertStringToValidURL } from "data/Utils";
import { ServiceEntryWidget } from "views/servicesEntry/ServiceEntryWIdget";

type State = {};

const markdownFiles = require.context("content/services", false, /\.\/.*md/i);

const fileKeys = markdownFiles.keys();

export class App extends React.Component<{}, State> {
  render() {
    return (
      <div className="App">
        <BrowserRouter>
          <Header />
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="/Home" element={<Homepage />} />
            <Route path="/Services" element={<Services />} />
            <Route path="/Contact" element={<Contact />} />
            {fileKeys.map((key) => {
              const urlifiedString = convertStringToValidURL(key);

              return (
                <Route
                  path={"/services/" + urlifiedString}
                  element={<ServiceEntryWidget caseStudyId={key} />}
                />
              );
            })}
            <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
          </Routes>
          <Footer />
        </BrowserRouter>
      </div>
    );
  }
}
